import { createFileRoute } from "@tanstack/react-router";
import { ConnectionsPage } from "@/features/settings/connections-page";

export const Route = createFileRoute("/_app/settings/connections")({ component: ConnectionsPage });
